import { default as GallectionDeviationManager } from './GallectionDeviationManager';
export default GallectionDeviationManager;

//# sourceMappingURL=index.js.map